import {
  PageWithHeader,
  Content,
  ContentHeader,
  SupportButton,
  Link,
  Button,
  LinkButton,
} from '@backstage/core-components';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { CatalogTable } from '@backstage/plugin-catalog';
import {
  EntityListProvider,
  CatalogFilterLayout,
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityNamespacePicker,
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntityTagPicker,
  EntityTypePicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import React from 'react';

export const CustomAPI = () => {
  return (
    <PageWithHeader title="Acuity API's" themeId="home">
      <Content>
        <ContentHeader title="">
          <LinkButton to="/catalog-import">Register your API</LinkButton>
          <SupportButton>
            <Link to="https://devportal.us.acuitynext.io/docs/default/component/zephyr-techdocs/product-documentation/user/end-user/catalog-system/register-api-doc/">
              Learn how to register your API's here
            </Link>
          </SupportButton>
        </ContentHeader>
        <EntityListProvider pagination>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker />
              <EntityTypePicker />
              <UserListPicker />
              <EntityOwnerPicker />
              <EntityLifecyclePicker />
              <EntityTagPicker />
              <EntityProcessingStatusPicker />
              <EntityNamespacePicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <CatalogTable />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </PageWithHeader>
  );
};
